import { lazy } from 'react'

export const PersonalizeYourPlan = lazy(() => import('./PersonalizeYourPlan'))
